var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZone1Path(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3840 2329.373",
    style: {
      enableBackground: "new 0 0 3840 2329.373"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "overall_path"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FA553A",
      strokeWidth: 49.9449,
      strokeMiterlimit: 10
    },
    d: "M2010.256,649.286h-599.889 c-45.786,0-82.903,37.117-82.903,82.903v177.367c0,22.812-8.939,44.715-24.9,61.013v0c-15.961,16.298-24.9,38.202-24.9,61.013 v357.371c0,29.236,19.556,54.859,47.756,62.572l0,0c20.435,5.589,36.332,20.584,43.536,39.543"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZone1Path);
export default __webpack_public_path__ + "static/media/zone1-path.d8d206c1.svg";
export { ForwardRef as ReactComponent };